import { Users } from "lucide-react";
import { initials } from "../lib/assignees";

const sizes = { sm: "w-5 h-5 text-[8px]", md: "w-7 h-7 text-[10px]" };

export const AssigneeAvatars = ({ assignees, size = "md", max = 3, className = "" }) => {
  if (!assignees?.length) return null;
  const shown = assignees.slice(0, max);
  const extra = assignees.length - shown.length;
  const ring = "border-2 border-white dark:border-[#232326] ring-1 ring-slate-100 dark:ring-white/10";
  return (
    <div data-testid="assignee-avatars" className={`flex items-center -space-x-2 ${className}`}>
      {shown.map((a) => a.type === "team" ? (
        <span key={a.key} title={`${a.name} (grup)`} data-testid="assignee-team-badge"
          className={`${sizes[size]} rounded-lg ${ring} text-white font-semibold flex items-center justify-center`}
          style={{ background: a.color || "#AF52DE" }}>
          <Users size={size === "sm" ? 9 : 12} />
        </span>
      ) : (
        <span key={a.key} title={a.name} data-testid="assignee-user-avatar"
          className={`${sizes[size]} rounded-full ${ring} text-white font-semibold flex items-center justify-center ${a.role === "admin" ? "bg-slate-900 dark:bg-slate-600" : "bg-[#007AFF]"}`}>
          {initials(a.name)}
        </span>
      ))}
      {extra > 0 && (
        <span className={`${sizes[size]} rounded-full ${ring} bg-slate-200 dark:bg-white/20 text-slate-600 dark:text-white font-semibold flex items-center justify-center`}>+{extra}</span>
      )}
    </div>
  );
};

export default AssigneeAvatars;
